export const appsAppGroupIdChartsLine = "/apps/:app_group_id/charts/line";
